import { Flex } from "antd"

const siteUrl = "members.hotel2sejour.com";
const companyName = "Paximum";
const countryState = "Türkiye/Antalya";
const contactMail = "support@paximum.com"

const TermsAndConditions_en = () => {
    return (
        <Flex vertical>
            <h2>Terms And Conditions</h2>
            <span> {`Welcome to ${siteUrl}! By accessing or using our website, you agree to comply with and be bound by the following terms and conditions. Please read them carefully before using our services.`}</span>
            <br />
            <strong>Acceptance of Terms</strong>
            <span>{`By accessing and using ${siteUrl}, you accept and agree to be bound by these terms and conditions. If you do not agree to these terms, you are prohibited from using or accessing this website.`}</span>
            <br />
            <strong>Use of the Website</strong>
            <span>You agree to use the website for lawful purposes only and not engage in any behavior that might damage, disable, or impair the website. You agree not to interfere with any other user’s enjoyment of the website.</span>
            <br />
            <strong>Intellectual Property Rights</strong>
            <span>{`All content, logos, images, designs, and text on this website are the property of ${companyName} and are protected by copyright, trademark, and other intellectual property laws. You may not use, reproduce, or distribute any content without prior written consent from ${companyName}.`}</span>
            <br />
            <strong>User Accounts</strong>
            <span>You may be required to create an account to access certain features. You are responsible for maintaining the confidentiality of your account details, and you agree to accept responsibility for all activities that occur under your account.</span>
            <br />
            <strong>Privacy Policy</strong>
            <span>Your use of the website is also governed by our Privacy Policy, which explains how we collect, use, and protect your personal information.</span>
            <br />
            <strong>Limitation of Liability</strong>
            <span>{`${companyName} is not liable for any damages that arise from your use of or inability to use this website. We do not guarantee that the website will be error-free or that any defects will be corrected.`}</span>
            <br />
            <strong>Third-Party Links</strong>
            <span>Our website may contain links to third-party websites or services. These links are provided for your convenience, and we do not endorse or take responsibility for the content or practices of those websites.</span>
            <br />
            <strong>Changes to Terms and Conditions</strong>
            <span>We reserve the right to modify these terms at any time. Any changes will be effective immediately upon posting on the website. It is your responsibility to review the terms periodically for updates.</span>
            <br />
            <strong>Governing Law</strong>
            <span>{`These terms and conditions are governed by and construed in accordance with the laws of ${countryState}, and you agree to submit to the exclusive jurisdiction of the courts located in ${countryState}.`}</span>
            <br />
            <strong>Termination</strong>
            <span>We reserve the right to suspend or terminate your access to the website if you violate these terms.</span>
            <br />
            <strong>Contact Us</strong>
            <span>{`If you have any questions or concerns regarding these terms and conditions, please contact us at ${contactMail}.`}</span>
        </Flex >
    )
}


const TermsAndConditions_tr = () => {
    return (
        <Flex vertical>
            <h2>Şartlar ve Koşullar</h2>
            <span> {`${siteUrl}'a hoş geldiniz! Web sitemize erişerek veya kullanarak, aşağıdaki şartlar ve koşullara uymayı ve bunlarla bağlı olmayı kabul ediyorsunuz. Lütfen hizmetlerimizi kullanmadan önce bunları dikkatlice okuyun.`}</span>
            <br />
            <strong>Şartların Kabulü</strong>
            <span>{`${siteUrl}'a erişerek ve kullanarak, bu şartlar ve koşullarla bağlı olmayı kabul ediyorsunuz. Bu şartları kabul etmiyorsanız, bu web sitesini kullanmanız yasaktır.`}</span>
            <br />
            <strong>Web Sitesinin Kullanımı</strong>
            <span>Web sitesini yalnızca yasal amaçlar için kullanmayı ve web sitesine zarar verebilecek, devre dışı bırakabilecek veya bozabilecek herhangi bir davranışta bulunmamayı kabul ediyorsunuz. Başka bir kullanıcının web sitesinden aldığı keyfi engellememeyi de kabul ediyorsunuz.</span>
            <br />
            <strong>Fikri Mülkiyet Hakları</strong>
            <span>{`Bu web sitesindeki tüm içerikler, logolar, görseller, tasarımlar ve metinler ${companyName}'un mülkiyetindedir ve telif hakkı, ticari marka ve diğer fikri mülkiyet yasalarıyla korunmaktadır. Önceden yazılı izin almadan herhangi bir içeriği kullanamaz, çoğaltamaz veya dağıtamazsınız.`}</span>
            <br />
            <strong>Kullanıcı Hesapları</strong>
            <span>Bazı özelliklere erişmek için bir hesap oluşturmanız gerekebilir. Hesap bilgilerinizi gizli tutmaktan siz sorumlusunuz ve hesabınız altında gerçekleşen tüm etkinliklerden sorumlu olduğunuzu kabul ediyorsunuz.</span>
            <br />
            <strong>Gizlilik Politikası</strong>
            <span>Web sitesini kullanımınız aynı zamanda kişisel bilgilerinizi nasıl topladığımızı, kullandığımızı ve koruduğumuzu açıklayan gizlilik politikamız tarafından da yönetilmektedir.</span>
            <br />
            <strong>Sorumluluğun Sınırlandırılması</strong>
            <span>{`${companyName}, bu web sitesini kullanımınızdan veya kullanamamanızdan kaynaklanan herhangi bir zarardan sorumlu değildir. Web sitesinin hatasız olacağını veya tüm kusurların düzeltileceğini garanti etmiyoruz.`}</span>
            <br />
            <strong>Üçüncü Taraf Bağlantıları</strong>
            <span>Web sitemiz, üçüncü taraf web sitelerine veya hizmetlerine bağlantılar içerebilir. Bu bağlantılar sizin kolaylığınız için sağlanmıştır ve bu web sitelerinin içeriklerinden veya uygulamalarından sorumlu değiliz ve bunları onaylamıyoruz.</span>
            <br />
            <strong>Şartlar ve Koşullarda Değişiklikler</strong>
            <span>Bu şartları herhangi bir zamanda değiştirme hakkımız saklıdır. Herhangi bir değişiklik, web sitesinde yayınlandığı anda yürürlüğe girecektir. Güncellemeler için şartları periyodik olarak gözden geçirmek sizin sorumluluğunuzdadır.</span>
            <br />
            <strong>Geçerli Hukuk</strong>
            <span>{`Bu şartlar ve koşullar ${countryState} yasalarına göre yönetilir ve yorumlanır ve ${countryState} mahkemelerin münhasır yargı yetkisini kabul edersiniz.`}</span>
            <br />
            <strong>Fesih</strong>
            <span>Bu şartları ihlal etmeniz durumunda, web sitesine erişiminizi askıya alma veya sonlandırma hakkımız saklıdır.</span>
            <br />
            <strong>Bize Ulaşın</strong>
            <span>{`Bu şartlar ve koşullar ile ilgili herhangi bir sorunuz veya endişeniz varsa, lütfen bize ${contactMail} üzerinden ulaşın.`}</span>
        </Flex >
    )
}

const PrivacyPolicy_en = () => {
    return (
        <Flex vertical>
            <h2>Privacy Policy</h2>
            <span>{`At ${companyName}, we highly value your privacy and are committed to protecting your personal data. This Privacy Policy explains how we collect, use, and protect the information gathered through our website or services.`}</span>
            <br />
            <strong>Information We Collect</strong>
            <span>We may collect personal data in various ways. The data collected can fall into the following categories:</span>
            <ul style={{ listStyle: "inside" }}>
                <li style={{ listStyle: "unset" }}>
                    Identity Information: Name, surname, email address, phone number.
                </li>
                <li style={{ listStyle: "unset" }}>
                    Contact Information: Address, email address, phone number.
                </li>
                <li style={{ listStyle: "unset" }}>
                    Usage Data: Information related to your use of our website, IP address, browser details.
                </li>
                <li style={{ listStyle: "unset" }}>
                    Cookies and Tracking Technologies: Usage data collected through cookies, pixel tags, and similar technologies.
                </li>
            </ul>
            <br />
            <strong>Use of Information</strong>
            <span>
                We may use the personal data we collect for the following purposes:
            </span>
            <ul style={{ listStyle: "inside" }}>
                <li style={{ listStyle: "unset" }}>
                    Providing and improving our services,
                </li>
                <li style={{ listStyle: "unset" }}>
                    Enhancing your user experience,
                </li>
                <li style={{ listStyle: "unset" }}>
                    Offering customer support,
                </li>
                <li style={{ listStyle: "unset" }}>
                    Complying with legal obligations,
                </li>
                <li style={{ listStyle: "unset" }}>
                    Conducting marketing and analytics activities.
                </li>
            </ul>
            <br />
            <strong> Sharing of Personal Data</strong>
            <span>We do not share your personal data with third parties, except in the following cases:</span>
            <ul style={{ listStyle: "inside" }}>
                <li style={{ listStyle: "unset" }}>
                    Legal requirements: When requested by authorized authorities.
                </li>
                <li style={{ listStyle: "unset" }}>
                    Business partners: With third parties we collaborate with to provide our services.
                </li>
                <li style={{ listStyle: "unset" }}>
                    Analytics and marketing services: To analyze user behavior and conduct advertising activities.
                </li>
            </ul>
            <br />
            <strong>Retention of Personal Data</strong>
            <span>Your personal data is retained only for as long as necessary. The retention period of your data may be extended in accordance with legal obligations and business needs.</span>
            <br />
            <strong>Security of Personal Data</strong>
            <span>We take industry-standard technical and administrative security measures to protect your personal data. However, please note that data transmission over the internet can never be completely secure.</span>
            <br />
            <strong>Your Rights</strong>
            <span>You have the following rights regarding your personal data:</span>
            <ul style={{ listStyle: "inside" }}>
                <li style={{ listStyle: "unset" }}>
                    Access to your personal data,
                </li>
                <li style={{ listStyle: "unset" }}>
                    Request the correction of your data,
                </li>
                <li style={{ listStyle: "unset" }}>
                    Request the deletion of your data,
                </li>
                <li style={{ listStyle: "unset" }}>
                    Restrict or object to the processing of your data.
                </li>
            </ul>
            <span>{`To exercise your rights, you can contact us via ${contactMail}.`}</span>
            <br />
            <strong> Cookies </strong>
            <span>We use cookies on our website. Cookies are small files stored on your browser and are used to personalize your user experience. You can modify your cookie settings through your browser.</span>
            <br />
            <strong> Third-Party Websites </strong>
            <span>
                Our website may contain links to other websites operated by third parties. We are not responsible for the privacy practices of these websites.
            </span>
            <br />
            <strong>Updates to This Policy</strong>
            <span>Our privacy policy may be updated from time to time. In case of any changes, the updated policy will be published on this page.</span>
            <br />
            <strong>Contact</strong>
            <span>{`For questions regarding our privacy policy, you can contact us via ${contactMail}.`}</span>
        </Flex >
    )
}

const PrivacyPolicy_tr = () => {
    return (
        <Flex vertical>
            <h2>Gizlilik Politikası</h2>
            <span>{`${companyName} olarak, gizliliğinize ve kişisel verilerinizin korunmasına büyük önem veriyoruz. Bu Gizlilik Politikası, web sitemiz veya hizmetlerimiz aracılığıyla topladığımız bilgilerin nasıl kullanıldığını ve korunduğunu açıklamaktadır.`}</span>
            <br />
            <strong>Topladığımız Bilgiler</strong>
            <span>Kişisel verilerinizi çeşitli şekillerde toplayabiliriz. Toplanan veriler aşağıdaki kategorilerde olabilir:</span>
            <ul style={{ listStyle: "inside" }}>
                <li style={{ listStyle: "unset" }}>
                    Kimlik Bilgileri: Ad, soyad, e-posta adresi, telefon numarası.
                </li>
                <li style={{ listStyle: "unset" }}>
                    İletişim Bilgileri: Adres, e-posta adresi, telefon numarası.
                </li>
                <li style={{ listStyle: "unset" }}>
                    Kullanım Verileri: Web sitemizi kullanımınıza ilişkin bilgiler, IP adresi, tarayıcı bilgileri.
                </li>
                <li style={{ listStyle: "unset" }}>
                    Çerezler ve İzleme Teknolojileri: Çerezler, piksel etiketleri ve benzeri teknolojiler aracılığıyla kullanım bilgileri.
                </li>
            </ul>
            <br />
            <strong>Bilgilerin Kullanımı</strong>
            <span>
                Topladığımız kişisel verileri aşağıdaki amaçlarla kullanabiliriz:
            </span>
            <ul style={{ listStyle: "inside" }}>
                <li style={{ listStyle: "unset" }}>
                    Hizmetlerimizin sağlanması ve geliştirilmesi,
                </li>
                <li style={{ listStyle: "unset" }}>
                    Kullanıcı deneyiminizin iyileştirilmesi,
                </li>
                <li style={{ listStyle: "unset" }}>
                    Müşteri desteği sunulması,
                </li>
                <li style={{ listStyle: "unset" }}>
                    Yasal yükümlülüklerin yerine getirilmesi,
                </li>
                <li style={{ listStyle: "unset" }}>
                    Pazarlama ve analiz faaliyetleri.
                </li>
            </ul>
            <br />
            <strong>Kişisel Verilerin Paylaşılması</strong>
            <span>Kişisel verilerinizi aşağıdaki durumlar haricinde üçüncü taraflarla paylaşmayız:</span>
            <ul style={{ listStyle: "inside" }}>
                <li style={{ listStyle: "unset" }}>
                    Yasal zorunluluklar: Yetkili makamların talepleri doğrultusunda.
                </li>
                <li style={{ listStyle: "unset" }}>
                    İş ortaklarımız: Hizmetlerimizi sağlamak amacıyla işbirliği yaptığımız üçüncü taraflarla.
                </li>
                <li style={{ listStyle: "unset" }}>
                    Analiz ve pazarlama hizmetleri: Kullanıcı davranışlarını analiz etmek ve reklam faaliyetleri yürütmek amacıyla.
                </li>
            </ul>
            <br />
            <strong>Kişisel Verilerin Saklanması</strong>
            <span>Kişisel verileriniz, yalnızca gerekli olduğu süre boyunca saklanır. Yasal zorunluluklar ve iş gereksinimleri doğrultusunda verilerinizin saklama süresi uzatılabilir.</span>
            <br />
            <strong>Kişisel Verilerin Güvenliği</strong>
            <span>Kişisel verilerinizi korumak için endüstri standartlarında teknik ve idari güvenlik önlemleri alıyoruz. Ancak internet üzerinden veri iletiminin tamamen güvenli olamayabileceğini hatırlatmak isteriz.</span>
            <br />
            <strong>Haklarınız</strong>
            <span>Kişisel verileriniz üzerinde aşağıdaki haklara sahipsiniz:</span>
            <ul style={{ listStyle: "inside" }}>
                <li style={{ listStyle: "unset" }}>
                    Kişisel verilerinize erişim,
                </li>
                <li style={{ listStyle: "unset" }}>
                    Verilerinizin düzeltilmesini talep etme,
                </li>
                <li style={{ listStyle: "unset" }}>
                    Verilerinizin silinmesini talep etme,
                </li>
                <li style={{ listStyle: "unset" }}>
                    Verilerinizin işlenmesini sınırlama ve itiraz etme.
                </li>
            </ul>
            <span>{`Haklarınızı kullanmak için bizimle ${contactMail} üzerinden irtibata geçebilirsiniz.`}</span>
            <br />
            <strong> Çerezler </strong>
            <span>Web sitemizde çerezler kullanmaktayız. Çerezler, tarayıcınıza kaydedilen küçük dosyalardır ve kullanıcı deneyiminizi kişiselleştirmek için kullanılır. Çerez ayarlarınızı tarayıcı üzerinden değiştirebilirsiniz.</span>
            <br />
            <strong> Üçüncü Taraf Web Siteleri</strong>
            <span>
                Web sitemiz, üçüncü tarafların işlettiği diğer web sitelerine bağlantılar içerebilir. Bu sitelerin gizlilik uygulamalarından sorumlu olmadığımızı belirtmek isteriz.
            </span>
            <br />
            <strong>Bu Politikanın Güncellenmesi</strong>
            <span>Gizlilik politikamız zaman zaman güncellenebilir. Herhangi bir değişiklik durumunda, güncellenmiş politikayı bu sayfa üzerinden yayımlayacağız.</span>
            <br />
            <strong>İletişim</strong>
            <span>{`Gizlilik politikamızla ilgili sorularınız için bizimle ${contactMail} üzerinden iletişime geçebilirsiniz.`}</span>
        </Flex >
    )
}


export { TermsAndConditions_en, TermsAndConditions_tr, PrivacyPolicy_en, PrivacyPolicy_tr };
